<div
  class="tabs-header bg-gray-100 rounded-lg shadow-md pl-6 px-2"
  [ngClass]="{ 'overflow-hidden': loading, 'overflow-x-auto': !loading }"
>
  @if (loading) {
    @let skeletons = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

    @for (skeleton of skeletons; track $index) {
      <div class="skeleton"><div class="h-6 w-22.5"></div></div>
    }
  } @else {
    @for (tab of tabs; track $index; let i = $index) {
      <div
        class="tab"
        [ngClass]="{ active: tab.active }"
        (click)="selectTab(i)"
      >
        {{ tab.label }}
      </div>
    }
  }
</div>

<div class="tabs-content">
  <ng-content></ng-content>
</div>
